import React from "react";
import type { SxProps, Theme } from "@mui/material/styles";
import { Box, Chip, Stack, Typography } from "@mui/material";

import { UserAvatar } from "../avatars";

export interface UserChipProps {
  name: string;
  roleChip?: React.ReactNode;
  avatarColor?: string;
  fullWidth?: boolean;
  sx?: SxProps<Theme>;
}

const UserChip: React.FC<UserChipProps> = ({
  name,
  roleChip,
  avatarColor,
  fullWidth = false,
  sx,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        width: fullWidth ? "100%" : "fit-content",
        gap: 1,
        pr: roleChip ? 0.5 : 1,
        borderRadius: 999,
        backgroundColor: "rgba(148, 163, 184, 0.08)",
        border: "1px solid rgba(148, 163, 184, 0.25)",
        boxSizing: "border-box",
        ...sx,
      }}
    >
      <UserAvatar
        text={name}
        color={avatarColor}
        sx={{
          width: 28,
          height: 28,
          fontSize: "0.85rem",
        }}
      />

      <Typography
        variant="body2"
        noWrap
        sx={{
          flex: 1,
          overflow: "hidden",
          textOverflow: "ellipsis",
          fontWeight: 600,
        }}
      >
        {name}
      </Typography>

      {roleChip && (
        <Box
          sx={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "flex-end",
            flexShrink: 0,
            ml: "auto",
          }}
        >
          {roleChip}
        </Box>
      )}
    </Box>
  );
};

export default UserChip;
